<template>
  <div>
    <div class="corzo-page-title-wrap corzo-style-custom corzo-left-align">
      <div class="corzo-header-transparent-substitute"></div>
      <div class="corzo-page-title-overlay"></div>
      <div class="corzo-page-title-container corzo-container">
        <div class="corzo-page-title-content corzo-item-pdlr">
          <div class="corzo-page-caption">News</div>
          <h1 class="corzo-page-title">{{ title }}</h1>
          <div class="corzo-page-caption-divider"></div>
        </div>
      </div>
    </div>

    <div class="corzo-page-wrapper" id="corzo-page-wrapper">
      <div class="gdlr-core-page-builder-body">
        <div class="gdlr-core-pbf-section">
          <div class="gdlr-core-pbf-section-container gdlr-core-container clearfix">
            <div class="gdlr-core-pbf-element">
              <div class="gdlr-core-blog-item gdlr-core-item-pdb clearfix gdlr-core-style-blog-column" style="padding-bottom: 40px;">
                <div class="gdlr-core-blog-item-holder gdlr-core-js-2 clearfix" data-layout="fitrows">
                  <div class="gdlr-core-item-list gdlr-core-item-pdlr gdlr-core-column-30 " v-for="news in list" :key="news.media_id" style="height: 640px;">
                    <div class="gdlr-core-blog-grid gdlr-core-style-2">
                      <div class="gdlr-core-blog-thumbnail gdlr-core-media-image gdlr-core-opacity-on-hover gdlr-core-zoom-on-hover">
                        <a @click="showNews(news)" style="cursor: pointer;">
                          <img :src="news.image" alt="" width="900" height="500" title="Conference">
                        </a>
                      </div>
                      <div class="gdlr-core-blog-grid-content-wrap">
                        <div class="gdlr-core-blog-info-wrapper gdlr-core-skin-divider">
                          <span class="gdlr-core-blog-info gdlr-core-blog-info-font gdlr-core-skin-caption gdlr-core-blog-info-date">
                            <span class="gdlr-core-blog-info-sep">•</span><span class="gdlr-core-head">
                            <i class="icon_clock_alt"></i></span>
                            <a href="#" style="cursor: pointer;" v-if="news.extra">{{ timeStamp2FullString(news.extra.update_time) }}</a>
                          </span>
                        </div>
                        <h3 class="gdlr-core-blog-title gdlr-core-skin-title" style="font-size: 30px; font-weight: 700; letter-spacing: 0px;">
                          <a @click="showNews(news)" style="cursor: pointer;">{{ news.title }}</a>
                        </h3>
                        <div class="gdlr-core-blog-content clearfix">
                          {{ news.title }}
                          <div class="clear"></div>
                          <a class="gdlr-core-excerpt-read-more gdlr-core-plain-text gdlr-core-hover-border" @click="showNews(news)" style="cursor: pointer;">
                            Read More<i class="fa fa-long-arrow-right"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
<!--                <div class="gdlr-core-pagination gdlr-core-style-circle gdlr-core-left-align gdlr-core-item-pdlr">-->
<!--                  <span aria-current="page" class="page-numbers current">1</span>-->
<!--                  <a class="page-numbers" href="singleblog.html">2</a>-->
<!--                  <a class="next page-numbers" href="singleblog.html"></a>-->
<!--                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'NewsList',
  data () {
    return {
      type: '',
      list: [],
      title: ''
    }
  },
  methods: {
    timeStamp2FullString (time) {
      var datetime = new Date()
      datetime.setTime(time * 1000)
      var year = datetime.getFullYear().toString()
      var month = (datetime.getMonth() + 1).toString()
      var day = datetime.getDate().toString()
      var hour = datetime.getHours().toString()
      var minute = datetime.getMinutes().toString()
      var second = datetime.getSeconds().toString()
      return year.padStart(2, '0') + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0') + ' ' + hour.padStart(2, '0') + ':' + minute.padStart(2, '0') + ':' + second.padStart(2, '0')
    },
    getList (type) {
      return axios.post('https://www.huidetrust.com/service/user.do/news/list', {
        page: 1,
        pageSize: 100,
        source: 'huide',
        position: type
      }).then(res => {
        this.list = res.data.result.list
      })
    },
    showNews (item) {
      if (item.type === 'wx') {
        // window.open('/#/news/media/' + news.param.media_id)
        window.open('https://www.huidetrust.com/service/user.do/news/media?media_id=' + item.param.media_id)
      } else {
        if (item.param.url !== '') {
          window.open(item.param.url)
        }
      }
    },
    change () {
      this.type = this.$route.params.type
      this.list = []
      if (this.type === '1') {
        this.title = '匯德动态'
      } else if (this.type === '2') {
        this.title = '媒体报道'
      } else if (this.type === '3') {
        this.title = '媒体报道'
      }
      this.getList(this.type)
    }
  },
  mounted () {
    this.change()
  },
  watch: {
    $route: 'change'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/NewsList.vue